<template>
  <a-form-model-item :label="field.label" :label-col="fieldLabelCol" :wrapper-col="fieldWrapperCol">
    <!-- 会场名称 -->
    <a-input v-if="field.key === 'name'" :value="form.name" allow-clear placeholder="会场名称" @change="handleInputChange('name', $event)" />

    <!-- 会场状态 -->
    <a-select v-else-if="field.key === 'status'" :value="form.status" allow-clear placeholder="会场状态" @change="handleSelectChange('status', $event)">
      <a-select-option v-for="(item, index) in options.statusList" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>

    <!-- 会场类型 -->
    <a-select v-else-if="field.key === 'activity'" :value="form.activity" allow-clear placeholder="会场类型" @change="handleSelectChange('activity', $event)">
      <a-select-option v-for="(item, index) in options.venueTypes" :key="index" :value="item.value">
        <a-tag :color="item.color">{{ item.label }}</a-tag>
      </a-select-option>
    </a-select>

    <!-- 创建人 -->
    <user-select v-else-if="field.key === 'creator'" :value="form.creator" allow-clear show-search show-all placeholder="创建人" @change="handleSelectChange('creator', $event)" />

    <!-- 时间筛选 -->
    <a-input-group v-else-if="field.key === 'dateRange'" compact>
      <a-select :value="form.time_field" style="width: 30%" placeholder="时间类型" @change="handleSelectChange('time_field', $event)">
        <a-select-option value="create_time">创建时间</a-select-option>
        <a-select-option value="update_time">更新时间</a-select-option>
        <a-select-option value="start_time">开始时间</a-select-option>
      </a-select>
      <a-date-picker :value="form.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleDateChange('start_time', $event)" />
      <a-date-picker :value="form.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleDateChange('end_time', $event)" />
    </a-input-group>

    <!-- 关联项目 -->
    <a-select v-else-if="field.key === 'projects'" :value="form.projects" mode="multiple" allow-clear placeholder="关联项目" @change="handleSelectChange('projects', $event)">
      <a-select-option v-for="(item, index) in options.projectOptions" :key="index" :value="item.id">{{ item.name }}</a-select-option>
    </a-select>

    <!-- 竞拍需求 -->
    <a-select v-else-if="field.key === 'requirements'" :value="form.requirements" mode="multiple" allow-clear show-search placeholder="竞拍需求" option-filter-prop="children" @change="handleSelectChange('requirements', $event)" @focus="handleSearchFocus('requirements')">
      <a-select-option v-for="item in searchData.requirements.data" :key="item.id" :value="item.id"> {{ item.title }} ({{ item.code }}) </a-select-option>
    </a-select>

    <!-- 参与团队 -->
    <a-select v-else-if="field.key === 'teams'" :value="form.teams" mode="multiple" allow-clear show-search placeholder="参与团队" option-filter-prop="children" @change="handleSelectChange('teams', $event)" @focus="handleSearchFocus('teams')">
      <a-select-option v-for="item in searchData.teams.data" :key="item.id" :value="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>
  </a-form-model-item>
</template>

<script>
import UserSelect from '@/components/User/UserSelect';

export default {
  name: 'VenueFilterFormItem',
  components: { UserSelect },
  props: {
    field: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true,
      default: () => ({
        statusList: [],
        venueTypes: [],
        projectOptions: []
      })
    },
    searchData: {
      type: Object,
      required: true,
      default: () => ({
        requirements: {
          searching: false,
          data: []
        },
        teams: {
          searching: false,
          data: []
        }
      })
    },
    reset: {
      type: Boolean,
      default: false
    },
    labelCol: {
      type: Object,
      default: null
    },
    wrapperCol: {
      type: Object,
      default: null
    }
  },
  computed: {
    fieldLabelCol() {
      return this.labelCol === null ? { span: this.field.labelSpan || 6 } : this.labelCol;
    },
    fieldWrapperCol() {
      return this.wrapperCol === null ? { span: this.field.wrapperSpan || 18 } : this.wrapperCol;
    }
  },
  methods: {
    handleInputChange(key, event) {
      this.$emit('change', { key, value: event.target.value });
    },

    handleSelectChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleDateChange(key, value) {
      this.$emit('change', { key, value });
    },

    handleSearchFocus(key) {
      this.$emit('search', { key, value: '' });
    }
  }
};
</script>

<style lang="less" scoped>
:deep(.ant-form-item) {
  margin-bottom: 0px;

  .ant-form-item-label {
    text-align: right;
    color: #495057;
    padding-right: 8px;
  }
}

:deep(.ant-input),
:deep(.ant-select),
:deep(.ant-picker),
:deep(.ant-tree-select),
:deep(.ant-input-group),
:deep(.ant-calendar-picker) {
  width: 100%;
}
</style>
